import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Reveal from '../../reveal';
import RevealSlideDown from '../../animations/reveal-slide-down';
import { Spring } from 'react-spring';
import ProjectBlurb from '../project-blurb';
import styles from './project-video-ads.module.css';

const ProjectVideoAds = props => {
  return (
    <Reveal>
      <RevealSlideDown isInView={props.isInView}>
        <ProjectVideoAdsContent {...props} />
      </RevealSlideDown>
    </Reveal>
  );
};

class ProjectVideoAdsContent extends Component {
  videosRefs = [{ name: 'videoOne' }, { name: 'videoTwo' }];

  componentDidMount() {
    const VimeoPlayer = require('@vimeo/player');
    const playerOne = new VimeoPlayer(this.refs[0]);
    const playerTwo = new VimeoPlayer(this.refs[1]);
  }
  render() {
    const { wrapperPadding, ads, video_id, blurb, animation } = this.props;

    return (
      <React.Fragment>
        <div
          className={styles.wrapper}
          style={{
            padding: wrapperPadding,
            opacity: animation.opacity,
            transform: animation.transform,
          }}
        >
          <div className={styles.videoWrapper}>
            {ads &&
              ads.map((ad, index) => {
                return (
                  <div key={index} className={styles.videoAd}>
                    <div
                      data-vimeo-id={ad.video_id}
                      data-vimeo-autoplay="true"
                      data-vimeo-muted="true"
                      data-vimeo-width="300"
                      data-vimeo-height="200"
                      data-vimeo-background="true"
                      ref={index}
                    />
                  </div>
                );
              })}
          </div>
          <ProjectBlurb blurb={blurb} />
        </div>
      </React.Fragment>
    );
  }
}

ProjectVideoAds.propTypes = {
  ads: PropTypes.array,
  blurb: PropTypes.string,
  wrapperPadding: PropTypes.string,
};

export default ProjectVideoAds;



// WEBPACK FOOTER //
// ./src/components/project/project-video-ads/index.js